import type { DealstackAiTransactionQuickFilter } from '@dealstack/shared/lib/backendClient';
import type { TransactionColumnKey } from './TransactionsPanel.types';

/** The panel's own search params, beside `WORKSPACE_PARAMS.quickFilter`. */
export const TRANSACTIONS_PANEL_PARAMS = {
	reasonFilter: 'txReason',
	sort: 'txSort',
} as const;

/**
 * Rows per request. The table reveals them a step at a time and fetches the next page once the reveal passes the
 * rows loaded; "Select all in this filter" covers every row, loaded or not.
 */
export const TRANSACTIONS_PAGE_SIZE = 100;

export const QUICK_FILTER_ORDER: readonly DealstackAiTransactionQuickFilter[] = [
	'all',
	'ready_to_merge',
	'needs_review',
	'potential_existing',
	'invalid',
	'discarded',
	'in_dealstack',
];

/** Shown for a value the document does not print. */
export const EMPTY_VALUE = '–';

/** The reason filter's "any reason" option. */
export const ANY_REASON = 'any';

/** The leading selection column and the trailing chevron column. */
export const SELECT_COLUMN_WIDTH = 40;
export const CHEVRON_COLUMN_WIDTH = 48;

/** Fits the widest English status chip, "Created in Dealstack" (about 152px), with the cell's 24px padding. */
export const STATUS_COLUMN_WIDTH = 180;

/**
 * What each data column keeps before the table scrolls sideways, as the design's own table does with Status pinned:
 * enough to tell two rows apart (a class name, a person, an issuer), and a date, "Number of units" and a cost in
 * full. The nine securities columns need 1314px, so the table scrolls at every viewport; the surplus is shared
 * evenly above that.
 */
export const COLUMN_MIN_WIDTH: Record<Exclude<TransactionColumnKey, 'status'>, number> = {
	issuer: 128,
	buyer: 128,
	seller: 128,
	type: 96,
	document: 160,
	security: 160,
	date: 136,
	units: 134,
	currency: 96,
	cost: 136,
};
